import {observable} from 'mobx';
import {DomainObject} from 'shared/store';

class FilterRow extends DomainObject {
  @observable attribute;
  @observable operator;
}

export default FilterRow;
